( function( app ) {
  const COMPONENT = {
    init: function() {
    },
    finalize: function() {
    },
  };

  app.registerComponent( 'card-vertical-scroll', COMPONENT );
} )( app );
